import React from 'react';

function HeadingH1({ ...props }) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <rect width="24" height="24" fill="none" />
      <path
        d="M4 6v12M4 12h8M12 6v12"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      />

      <text
        x="15"
        y="19"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="10"
        fontWeight="bold"
        fill="currentColor"
      >
        1
      </text>
    </svg>
  );
}

export default HeadingH1;
